// extracted by mini-css-extract-plugin
module.exports = {"main":"ShowCode__main__GuQeH","code":"ShowCode__code__lJa28","label":"ShowCode__label__qSBUL","tool":"ShowCode__tool__uFTGd"};